import registerWithErrorBoundary from '@utils/registerWithErrorBoundary';

import ReferralSubscription from '@components/pages/Referral/Subscription/index';

registerWithErrorBoundary({
  ReferralSubscription,
});
